<template>
    <div>
        <div class="row">
            <div class="col-sm-6 col-xl-3" v-for="box in dashboardSalesSummaryBox" :key="box.id">
                <div class="p-3 rounded overflow-hidden position-relative text-white mb-g" :class="box.background">
                    <h3 class="fs-xxl d-block l-h-n m-0 fw-500">
                        {{box.value}}
                        <small class="mt-2 m-0 l-h-n fw-400 text-capitalize">{{box.id == 'tyMonthlyAvg' ? thisYear + $t('label.monthly_avg') : getBoxText(box.id)}}</small>
                    </h3>
                    <i class="fal position-absolute pos-right pos-bottom opacity-15 mb-n1 mr-n1" :class="box.icon" style="font-size:5rem"></i>
                </div>
            </div>
        </div>
        <div class="panel">
            <div class="panel-hdr"><h2 class="ui-sortable-handle">{{$t('header.monthly_sales')}}</h2></div>
            <div class="panel-container">
                <div class="panel-content">
                    <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                        {{$t('message.data.fetching', {'item': $t('header.monthly_sales')})}}
                        <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                    </div>
                    <dashboardMonthlySales v-if="!isSpinnerShow && barChartData.length != 0" :barChartData="barChartData"></dashboardMonthlySales>
                    <div v-if="!isSpinnerShow" class="row mt-3">
                        <div class="col-sm-12 overflow-auto">
                             <table class="table table-sm table-hover table-bordered table-striped text-center" role="grid" style="height: 1px">
                                <thead class="thead-themed">
                                    <tr>
                                        <th v-for="(tblHeader, i) in tblHeaders" :key="i">{{tblHeader}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th><i :class="thisYear != lastYear ? 'color-success-50' : 'color-primary-50'" class="fas fa-square-full mr-2"></i>{{lastYear}}</th>
                                        <td v-for="(item, i) in barChartData[0].data" :key="i">{{item == 0 ? '-' : item}}</td>
                                        <td>{{thisYear != lastYear ? getTotalData('lastYearSales') : getTotalData('thisYearSales')}}</td>
                                    </tr>
                                    <tr v-if="thisYear != lastYear">
                                        <th><i class="fas fa-square-full color-primary-50 mr-2"></i>{{thisYear}}</th>
                                        <td v-for="(item, i) in barChartData[1].data" :key="i">{{item == 0 ? '-' : item}}</td>
                                        <td>{{getTotalData('thisYearSales')}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <div class="panel">
                    <div class="panel-hdr">
                        <h2 class="ui-sortable-handle">{{$t('header.category_sales')}}</h2>
                        <div class="panel-toolbar">
                             <multiselect :value="selectedType" label="text" track-by="id" :options="type" :searchable="false" :show-labels="false" openDirection="below" @select="filterByType">
                                <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                            </multiselect>
                        </div>
                    </div>
                    <div class="panel-container">
                        <div class="panel-content">
                            <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                                {{$t('message.data.fetching', {'item': $t('header.category_sales')})}}
                                <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                            </div>
                            <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">{{$t('table.no_records')}}</div>
                            <dashboardSalesCategory v-if="!isSpinnerShow && dataThisYear.length != 0" :pieChartData="pieChartData"></dashboardSalesCategory>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="panel">
                    <div class="panel-hdr"><h2 class="ui-sortable-handle">{{$t('header.type_sales')}}</h2></div>
                    <div class="panel-container">
                        <div class="panel-content">
                            <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                                {{$t('message.data.fetching', {'item': $t('header.type_sales')})}}
                                <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                                <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                            </div>
                            <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">{{$t('table.no_records')}}</div>
                            <dashboardSalesType v-if="!isSpinnerShow && dataThisYear.length != 0" :dougnutChartData="dougnutChartData"></dashboardSalesType>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel">
            <div class="panel-hdr"><h2 class="ui-sortable-handle">{{$t('header.cont_items')}}</h2></div>
            <div class="panel-container">
                <div class="panel-content">
                    <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">{{$t('table.no_records')}}</div>
                    <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                        {{$t('message.data.fetching', {'item': $t('header.cont_items')})}}
                        <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                    </div>
                    <div v-if="!isSpinnerShow && dataThisYear.length != 0" class="row mt-3">
                        <div class="col-sm-12 overflow-auto">
                            <b-table small striped hover bordered :fields="tblHdrTopItems" :items="topSalesData" :sort-compare="sortTable" responsive="sm">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>
                                <template #cell(type)="data">
                                    <span v-if="data.item.type == 'service'" class="badge fw-400 bg-success-900 badge-success">{{$t('subMenu.salon_menu_service')}}</span>
                                    <span v-else-if="data.item.type == 'product'" class="badge fw-400 bg-danger-900 badge-danger">{{$t('subMenu.salon_menu_product')}}</span>
                                    <span v-else-if="data.item.type == 'package'" class="badge fw-400 bg-primary-900 badge-primary">{{$t('subMenu.salon_menu_package')}}</span>
                                    <span v-else class="badge fw-400 badge-warning">{{$t('subMenu.salon_report_outstandings')}}</span>
                                </template>
                                <template #cell(category)="data">
                                    {{data.item.type == 'outstandings' ? '-' : getCategoryText(data.item.type, data.item.category)}}
                                </template>
                                <template #cell(amount)="data">
                                    {{parseFloat(data.item.subTotal).toFixed(2)}}
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel">
            <div class="panel-hdr"><h2 class="ui-sortable-handle">{{$t('header.spending_members')}}</h2></div>
            <div class="panel-container">
                <div class="panel-content">
                    <div class="panel-tag" v-if="!isSpinnerShow && dataThisYear.length == 0">{{$t('table.no_records')}}</div>
                    <div class="panel-tag loading-panel-tag mt-3" v-if="isSpinnerShow">
                        {{$t('message.data.fetching', {'item': $t('header.spending_members')})}}
                        <b-spinner class="ml-1 small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                        <b-spinner class="small-spinner" variant="secondary" type="grow"></b-spinner>
                    </div>
                    <div v-if="!isSpinnerShow && dataThisYear.length != 0" class="row mt-3">
                        <div class="col-sm-12 overflow-auto">
                            <b-table small striped hover bordered :fields="tblHdrTopSpendingMember" :items="topSpendingMembers" :sort-compare="sortTable" responsive="sm">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>
                                <template #cell(name)="data">
                                    <i class="fal fa-user text-primary mr-2"></i>
                                    <a class="text-primary fw-500 link" :title="$t('button_link.view') + $t('header.spending_items')" @click="showMemberItems(data.item.item, data.item.subTotal)">{{data.item.name}}</a>
                                </template>
                                <template #cell(noItem)="data">{{data.item.count}}</template>
                                <template #cell(amount)="data">{{parseFloat(data.item.subTotal).toFixed(2)}}</template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div :class="{'show': toggleModal }" class="modal fade">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header border-bottom">
                        <h5 class="modal-title h4">{{$t('header.spending_items')}} - <span class="m-0 fw-300 text-muted">"{{sTitle}}"</span>
                        </h5>
                        <button type="button" class="close" @click="toggleModal = false">
                            <span aria-hidden="true"><i class="fal fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="dataTables_wrapper dt-bootstrap4">
                            <div class="row" data-spy="scroll" data-target="#itemSP" data-offset="0">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table small striped hover bordered :fields="tblHdrTopSpendingMemberItem" :items="topSpendingMemberItems" :sort-compare="sortTableMemberItem" responsive="sm">
                                        <template #cell(index)="data">
                                            {{ data.index + 1 }}
                                        </template>
                                        <template #cell(title)="data">{{data.item.item.title}}</template>
                                        <template #cell(type)="data">
                                            <span v-if="data.item.type == 'service'" class="badge fw-400 bg-success-900 badge-success">{{$t('subMenu.salon_menu_service')}}</span>
                                            <span v-else-if="data.item.type == 'product'" class="badge fw-400 bg-danger-900 badge-danger">{{$t('subMenu.salon_menu_product')}}</span>
                                            <span v-else-if="data.item.type == 'package'" class="badge fw-400 bg-primary-900 badge-primary">{{$t('subMenu.salon_menu_package')}}</span>
                                            <span v-else class="badge fw-400 badge-warning">{{$t('subMenu.salon_report_outstandings')}}</span>
                                        </template>
                                        <template #cell(category)="data">
                                            {{data.item.item.type == 'outstandings' ? '-' : getCategoryText(data.item.item.type, data.item.item.category)}}
                                        </template>
                                        <template #cell(amount)="data">
                                            {{parseFloat(data.item.subTotal).toFixed(2)}}
                                        </template>
                                        <template #custom-foot>
                                            <b-tr>
                                                <b-td class="border-top-bottom-2 text-right fw-700" colspan="4">{{$t('table.header.total', {'item': ''})}}</b-td>
                                                <b-td class="border-top-bottom-2 fw-500">{{memberItemTotal}}</b-td>
                                            </b-tr>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment'
import DashboardMonthlySales from './Dashboard_Monthly_Sales'
import DashboardSalesCategory from './Dashboard_Sales_Category'
import DashboardSalesType from './Dashboard_Sales_Type'
import {formatPrice, setAYearArr} from './../../assets/js/dashboard/utilities'
import cst, {calculateSalesReportTotal, getSubTotal} from './../../assets/js/dashboard/salonReport/salonReport'
export default {
    name: "salesSummary",
    components:{
        DashboardMonthlySales, DashboardSalesCategory, DashboardSalesType
    },
    data(){
        return{
            dashboardSalesSummaryBox: [],
            tblHeaders: [],
            type: [], selectedType: {},
            dataThisYear: [], dataLastYear: [],
            thisYear: moment().format('YYYY'),
            lastYear: moment().format('YYYY'),
            barChartData: [], pieChartData: [], dougnutChartData: [], 
            topSalesData: [], topSpendingMembers: [], topSpendingMemberItems: [],
            fPieChartData: [],
            isSpinnerShow: true, toggleModal: false, sTitle: "", memberItemTotal: 0,
        }
    },
    computed:{
        tblHdrTopItems(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle', tdClass: 'align-middle'},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "type", label: this.$i18n.t('table.header.type'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "category", label: this.$i18n.t('table.header.category'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "quantity", label: this.$i18n.t('table.header.quantity'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "amount", label: this.$i18n.t('table.header.subtotal'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        },
        tblHdrTopSpendingMember(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "name", label: this.$i18n.t('table.header.name'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
                { key: "noItem", label: this.$i18n.t('table.header.no_order'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "amount", label: this.$i18n.t('table.header.sales_amount'), thClass: 'thead-themed align-middle', sortable: true},
            ]
        },
        tblHdrTopSpendingMemberItem(){
            var arr = JSON.parse(JSON.stringify(this.tblHdrTopItems))
            var fArr = arr.filter(obj=> obj.key != 'quantity')
            return fArr
        }
    },
    watch:{
        "$i18n.locale"(val){
            this.tblHeaders = []
            this.tblHeaders.push("")
            this.tblHeaders.push(...this.$i18n.messages[this.$i18n.locale].calendar)
            this.tblHeaders.push(this.$i18n.t('table.header.total', {'item': ''}))

            this.setItemTypes()
            var b = Object.assign({}, this.selectedType)
            this.selectedType = this.type.filter(obj=> obj.id == b.id)
        }
    },
    methods:{
        sortTable(a, b, key){
            if(key == 'noItem'){
                return a.count - b.count
            }else if(key == 'amount'){
                return a.subTotal - b.subTotal
            }
            return false
        },
        sortTableMemberItem(a, b, key){
            if(key == 'title'){
                return a.item.title.localeCompare(b.item.title)
            }
            return false
        },
        filterByType(item){
            this.selectedType = item
            var newData = []
            if(item.id != "all"){
                for(var i=0; i<this.fPieChartData.length; i++){
                    if(this.fPieChartData[i].item.type == item.id){
                        newData.push(this.fPieChartData[i])
                    }
                }
                this.pieChartData = this.setPieChartData(newData) 
            }else{
                this.pieChartData = this.setPieChartData(this.fPieChartData) 
            }
        },
        getTotalData(id){
            var box = this.dashboardSalesSummaryBox.filter(function(el) { return el.id == id }); 
            return box[0].value
        },
        getCategoryText(type, id){
            var categoryList = JSON.parse(this.$store.state.category);
            var category = categoryList[type]
            
            var text = ""
            for(var i=0; i<category.length; i++){
                if(i == id){
                    text =  this.$i18n.t('label.category') + ' ' + (i+1) + '- ' + category[i]
                    break;
                }
            }
            return text
        },
        getBoxText(id){
            var text = (id == 'thisYearSales' ? this.thisYear : this.lastYear) + this.$i18n.t('label.annual_sales')
            return text
        },
        setSummaryData(thisYear, lastYear){
            var summaryBox = cst.dashboardSalesSummaryBox;
            this.isSpinnerShow = true

            this.thisYear = thisYear.date
            this.lastYear = lastYear.date
            this.dataThisYear = thisYear.data
            this.dataLastYear = lastYear.data

            var tySummary = calculateSalesReportTotal(thisYear.data)  
            var thisYearObj = setAYearArr(this.thisYear)

            var index = 0
            for(var m in thisYearObj){
                for(var l=0; l<thisYear.data.length; l++){
                    var createDate = new Date(thisYear.data[l].createDate*1000);
                    if(createDate.getMonth() == index){
                        thisYearObj[m].push(thisYear.data[l])
                    }
                }
                index++;
            }
            const counter = _.filter(thisYearObj, obj=> Object.values(obj).length != 0).length;

            this.dashboardSalesSummaryBox = summaryBox.slice()

            this.dashboardSalesSummaryBox[0].value = formatPrice(tySummary.totalSales);
            this.dashboardSalesSummaryBox[2].value = counter == 0 ? '-' : formatPrice(tySummary.totalSales/counter) 

            if(this.thisYear != this.lastYear){
                var lySummary = calculateSalesReportTotal(lastYear.data)

                var lastYearObj = setAYearArr(this.lastYear)
                var idx = 0
                for(var n in lastYearObj){
                    for(var j=0; j<lastYear.data.length; j++){
                        var cDate = new Date(lastYear.data[j].createDate*1000);
                        if(cDate.getMonth() == idx){
                            lastYearObj[n].push(lastYear.data[j])
                        }
                    }
                    idx++;
                }
                this.dashboardSalesSummaryBox[1].value = formatPrice(lySummary.totalSales);

                this.barChartData = this.setBarChartData(thisYearObj, lastYearObj)
            }else{
                this.dashboardSalesSummaryBox = this.dashboardSalesSummaryBox.filter(function(el) { return el.id != "lastYearSales"; }); 
                this.barChartData = this.setBarChartData(thisYearObj, {})
            }
            this.fPieChartData = thisYear.data.slice()
            this.pieChartData = this.setPieChartData(thisYear.data) 
            this.dougnutChartData = this.setDoughnutChartData(thisYear.data)
            this.topSpendingMembers = this.setTopItemsMember(thisYear.data)
            this.topSalesData = this.setTopItems(thisYear.data)
            this.isSpinnerShow = false
        },
        setBarChartData(thisYearObj, lastYearObj){
            var barChartData = []
            if(Object.keys(lastYearObj).length != 0){
                var lastYear = Object.assign({}, lastYearObj)
                var arrLastYear = []

                for(var n in lastYear){
                    var lySummary = calculateSalesReportTotal(lastYear[n])
                    arrLastYear.push(parseFloat(lySummary.totalSales).toFixed(2))
                }

                barChartData.push({
                    label: this.lastYear,
                    borderWidth: 1,
                    borderColor: "#1dc9b7",
                    backgroundColor: "#7aece0",
                    data: arrLastYear
                })
            }

            var thisYear = Object.assign({}, thisYearObj)
            var arrThisYear = []

            for(var m in thisYear){
                var tySummary = calculateSalesReportTotal(thisYear[m])
                arrThisYear.push(parseFloat(tySummary.totalSales).toFixed(2))
            }

            barChartData.push({
                label: this.thisYear,
                borderWidth: 1,
                borderColor: "#886ab5",
                backgroundColor: "#ccbfdf",
                data: arrThisYear
            })
            return barChartData
        },
        setPieChartData(thisYearObj){
            var thisYear = _.groupBy(thisYearObj.slice(), "item.category") 

            var data = []
            for(var m in thisYear){
                var tySummary = calculateSalesReportTotal(thisYear[m])
                data.push(parseFloat(tySummary.totalSales).toFixed(2))
            }
            return data
        },
        setDoughnutChartData(thisYearObj){
            var thisYear = _.groupBy(thisYearObj.slice(), "item.type") 

            var data = []
            var label = []
            for(var m in thisYear){
                if(m != 'discount'){
                    var tySummary = calculateSalesReportTotal(thisYear[m])
                    data.push(parseFloat(tySummary.totalSales).toFixed(2))
                    label.push(m)
                    // label.push(m.charAt(0).toUpperCase() + m.slice(1))
                } 
            }
            var obj = {
                data: data,
                label: label
            }
            return obj
        },
        setTopItems(thisYearObj){
            var thisYear =  _.groupBy(thisYearObj.slice(), "item.itemID") 

            var data = []
            for(var m in thisYear){
                var tySummary = calculateSalesReportTotal(thisYear[m])
                data.push({
                    itemID: m,
                    title: thisYear[m][0].item.title,
                    type: thisYear[m][0].item.type,
                    category: thisYear[m][0].item.category,
                    quantity: thisYear[m].length,
                    subTotal: tySummary.totalSales
                })
            }
            data.sort((a, b) => b.subTotal - a.subTotal);
            data = data.length > 30 ? data.slice(0, 30) : data
            return data
        },
        setTopItemsMember(thisYearObj){
            var thisYear =  _.groupBy(thisYearObj.slice(), "member.memberID") 
            var data = []
            for(var m in thisYear){
                var tySummary = calculateSalesReportTotal(thisYear[m])
                data.push({
                    memberID: m,
                    item: thisYear[m],
                    count: _.filter(thisYear[m], obj=> obj.redeem == "" && obj.item.type != "discount").length,
                    name: thisYear[m][0].member.displayName,
                    mobile: thisYear[m][0].member.mobile,
                    subTotal: tySummary.totalSales
                })
            }
            data.sort((a, b) => b.subTotal - a.subTotal);
            data = data.length > 30 ? data.slice(0, 30) : data
            return data
        },
        showMemberItems(item, total){
            var data = []
            for(var i=0; i<item.length; i++){
                if(item[i].redeem == ""){
                    if(item[i].item.type != 'discount'){
                        item[i].quantity = 1
                        item[i].subTotal = getSubTotal(item[i].price, item[i].discount, item[i].outstandings, item[i].tax.taxType, item[i].tax.tax)
                        data.push(item[i])
                    }
                }
            }
            data.sort((a, b) => b.subTotal - a.subTotal);
            this.topSpendingMemberItems = data
            this.memberItemTotal = parseFloat(total).toFixed(2)

            this.toggleModal = true
            this.sTitle = item[0].member.displayName
        },
        setItemTypes(){
            this.type = []
            var itemType = this.$i18n.messages[this.$i18n.locale].salon_report.item_types
            this.type.push(
                {id: "all", text: this.$i18n.t('label.all', {'item': this.$i18n.t('label.item_type')})}
            )
            for(var i in itemType){
                if(i != 'discount' && i != 'outstandings'){
                    this.type.push({
                        id: i,
                        text: itemType[i]
                    })
                }
            }
        }
    },
    mounted(){
        let $vm = this
        $vm.tblHeaders.push("")
        $vm.tblHeaders.push(...$vm.$i18n.messages[$vm.$i18n.locale].calendar)
        $vm.tblHeaders.push($vm.$i18n.t('table.header.total', {'item': ''}))

       

        $vm.setItemTypes()
        $vm.selectedType = {id: "all", text: $vm.$i18n.t('label.all', {'item': $vm.$i18n.t('label.item_type')})}
    }
}
</script>
<style scoped>
.loading-panel-tag {
    border-color: #909090 !important;
    background-color: #f1f1f1 !important;
}
.small-spinner{
    width: .25em;
    height: .25em;
    vertical-align: middle;
    margin-right: .25em;
}
.show{
    display: block;
}
.border-top-bottom-2{
    border-top-width:  2px !important;
    border-bottom-width:  2px !important;
}
.modal-body{
    max-height: 80vh;
    min-height: 80vh;
    overflow-y: auto;
}
</style>